import { withTranslation } from "react-i18next";

function ProfileContainer() {
  return <div>Profile Component</div>;
}

// TODO: remove with translation as hole app exported with translation
export default withTranslation()(ProfileContainer);
